

export default {
    inviteIndex: '/api/v2/invite/inviteIndex',
    buttonContent: '/api/v2/invite/buttonContent'
}
